import * as React from 'react';
import cn from 'classnames';
import { Stage, Props as StageProps } from '../Stage';

import './index.scss';

interface Props {
  className?: string;
  count: number;
  currency: string;
  max: number;
  onClick: StageProps['onClick'];
}

export const Stages: React.FC<Props> = ({ className, count, max, currency, onClick }) => {
  const stages = Array(count + 1)
    .fill(true)
    .map((_, i) => Math.floor((max * i) / count));

  return (
    <div className={cn('amount-input-stages', className)}>
      {max >= count &&
        stages.map((value) => <Stage key={value} amount={{ value, currency }} onClick={onClick} />)}
    </div>
  );
};
